import React from 'react';
import PropTypes from 'prop-types';

const TopicBox = props => {
  const {
    title,
    classNames: passedClassNames = [],
    wrapperTagName: WrapperTagName = 'article',
    children
  } = props;

  const classNames = [...passedClassNames, 'topic-box'];

  return (
    <WrapperTagName className={classNames.join(' ')}>
      <h1>{title}</h1>
      {children}
    </WrapperTagName>
  );
};

TopicBox.propTypes = {
  title: PropTypes.string.isRequired,
  classNames: PropTypes.arrayOf(PropTypes.string),
  wrapperTagName: PropTypes.string
};

export default TopicBox;